import React from 'react'
import { Link } from "gatsby"

import "../style/post.css"

const BlogPost = ({ title, slug, date, body, time}) => {
    return (
        <div className="space-y-4 __post-article">
            <Link to={'/'+slug}>
            <div className="mt-8 md:mt-12">
                    <h2 className="text-3xl font-bold tracking-tight dark:text-BaseLight sm:text-3xl md:text-4xl md:font-bold lg:text-6xl lg:font-bold lg:leading-tight highlight" data-content={title}>{title}</h2>

            </div>
            <div>

                    <p className="text-xl font-normal leading-snug tracking-tight md:font-semibold md:text-xl dark:text-BaseLight lg:text-4xl lg:font-bold highlight" data-content={body}>{body}</p>

            </div>
            <div>

                    <p className="text-sm font-medium tracking-tight dark:text-BaseLight lg:text-2xl highlight md:text-base" data-content={date+' · '+time+' minute read'}><span>{date}&nbsp;&middot;&nbsp;</span><span>{time}&nbsp;minute read</span></p>

            </div>
            </Link>
        </div>
    )
}

export default BlogPost
